export default __webpack_public_path__ + "static/media/benefits_new_pantheon.b1423f11.png";